import ApiService from "@/core/services/api.service";

// action types
export const GET_ODATA_LIQUIDACIONES = "getODataLiquidaciones";
export const GET_ALL_ODATA_LIQUIDACIONES = "getAllODataLiquidaciones";
export const GET_ODATA_LIQUIDACIONES_CORREDOR = "getODataLiquidacionesCorredor";
// mutation types
export const SET_ODATA_COMISIONES = "setODataComisiones";
export const SET_ODATA_BOOKING = "setODataBooking";
export const SET_ERROR = "setError";
//const urlBase = 'https://apifacturacionbot.contemporaseguros.com/OdataLiquidacion'
//const urlBase = 'https://localhost:44397' 

const state = {
  errors: null,
  comisiones: []
};

const actions = {

  [GET_ODATA_LIQUIDACIONES](context, query) {

    let { page, page_size, filter } = query;
    filter = (filter === undefined) ? "" : filter;
    let url = `?$count=true${filter}`;

    if (page_size !== -1) {
      //   let skip = (page - 1) * page_size;
      let skip = 0;
      page_size = 10;
      url = `?$top=${page_size}&$skip=${skip}&$count=true${filter}&$orderby=anio desc,mes desc,numeroDocumento desc,moneda`;
    }

    return new Promise(resolve => {
      //ApiService.setHeader();

      ApiService.get({ action: `/OdataLiquidacion/odata/Liquidacion` }, url)
      // Dev
    //   ApiService.get({ action: `https://localhost:44397/odata/Liquidacion` }, url)
        .then(({ data }) => {
          // context.commit(SET_ODATA_COMISIONES, data);//no guardamos el estado
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log((response)
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [GET_ALL_ODATA_LIQUIDACIONES](context, query) {

    // let { page , page_size, filter } = query;
    // filter = (filter === undefined) ? "" : filter;
    // let url = `?$count=true${filter}`;

    // if(page_size !== -1) {
    //   let skip = (page - 1) * page_size;
    //   url = ``;
    // }
    let url = ``;
    return new Promise(resolve => {
      //ApiService.setHeader();

      ApiService.get({ action: `/OdataLiquidacion/odata/Liquidacion` }, url)
        .then(({ data }) => {
          // context.commit(SET_ODATA_COMISIONES, data);//no guardamos el estado
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log((response)
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [GET_ODATA_LIQUIDACIONES_CORREDOR](context, query) {

    let { page, page_size, filter, rut, year, month, codigoRol } = query;
    // filter = (filter === undefined) ? "" : filter;
    // let url = `?$count=true${filter}`;

    // if(page_size !== -1) {
    //   let skip = (page - 1) * page_size;
    //   url = `?$top=${page_size}&$skip=${skip}&$count=true${filter}&$orderby=anio desc,mes desc,numeroDocumento desc,moneda`;
    // }

    return new Promise(resolve => {
      ApiService.setHeader();

      //    ApiService.get({action: `/OdataLiquidacion/odata/Liquidacion`}, url)
      ApiService.get({ action: `/facturacioncomisionapi/api/Liquidacion/v1/GetLiquidacionesCorredor?RutCorredor=${rut}&Anio=${year}&Mes=${month}&Page=${page}&PageSize=${page_size}&CodigoRol=${codigoRol}&end=` })
      // Dev
    //   ApiService.get({ action: `/api/Liquidacion/v1/GetLiquidacionesCorredor?RutCorredor=${rut}&Anio=${year}&Mes=${month}&Page=${page}&PageSize=${page_size}&CodigoRol=${codigoRol}&end=` })
        .then(({ data }) => {
          // context.commit(SET_ODATA_COMISIONES, data);//no guardamos el estado

          //FIX DATA NAMES
          var newData = []
          data.forEach(element => {
            newData.push({
              LiquidacionId: element.liquidacionId,
              CodigoAgente: element.codigoAgente,
              Mes: element.mes,
              Anio: element.anio,
              RutCorredor: element.rutCorredor,
              RutCorredorDv: element.rutCorredorDv,
              NombreCorredor: element.nombreCorredor,
              Moneda: element.moneda,
              TipoCambio: element.tipoCambio,
              MontoComisionAfecta: element.montoComisionAfecta,
              MontoComisionExenta: element.montoComisionExenta,
              MontoAfectaUF: element.montoAfectaUF,
              MontoExentaUF: element.montoExentaUF,
              AfectoNeto: element.afectoNeto,
              ImpuestoAfecta: element.impuestoAfecta,
              TotalAfecta: element.totalAfecta,
              ExentoNeto: element.exentoNeto,
              ImpuestoExenta: element.impuestoExenta,
              TotalExenta: element.totalExenta,
              Neto: element.neto,
              ImpuestoTotal: element.impuestoTotal,
              TotalGirar: element.totalGirar,
              FechaCreacion: element.fechaCreacion,
              Estado: element.estado,
              NumeroDocumento: element.numeroDocumento == 0 ? '' : element.numeroDocumento,
              FechaFacturacionBoleta: element.fechaFacturacionBoleta,
              StatusCode: element.statusCode,
              TipoMovimiento: element.tipoMovimiento,
              Movimiento: element.movimiento,
              TotalComision: element.totalComision,
              TipoDocumento: element.tipoDocumento,
            })
          })

          resolve(newData)
        })
        .catch(({ response }) => {
          //console.log((response)
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_ODATA_COMISIONES](state, comisiones) {
    state.error = {};
    state.comisiones = comisiones;
  },
  [SET_ODATA_BOOKING](state, booking) {
    state.error = {};
    state.booking = booking;
  }
};

export default {
  state,
  actions,
  mutations
};
